import { connect } from 'react-redux';
import {
  getMetricsByJobId,
  getDisplayMetrics,
  getPageType,
  getExportMetrics
} from './../reducers';
import JobMetricsInfoComponent
  from './../Components/JobMetricsInfoComponent.jsx';
import { pageTypes } from './../helpers';

const metricsDisplayList =
  [ 'CCF_ARTIFACTHITCOUNT',
    'CCF_DIFFDURATION',
    'CCF_DIFFRESULT',
    'CCF_DEFINITIONDIFFRESULT',
    'CCF_SEARCHDURATION',
    'NCF_ARTIFACTHITCOUNT',
    'NCF_DIFFDURATION',
    'NCF_DIFFRESULT',
    'NCF_DEFINITIONDIFFRESULT',
    'NCF_SEARCHDURATION',
    'QUEUINGDURATIONMILLIS',
    'ACTION',
    'CATEGORY',
    'DEVICEENCRYPTION',
    'DEVICEMODEL',
    'DEVICEROOTSTATUS',
    'DEVICETYPE',
    'IMAGECREATIONDURATION',
    'IMAGETYPE',
    'LABEL',
    'MANUFACTURER',
    'OSVERSION',
    'VALIDATORRESULT',
    'EXCLUDEATTACHMENTS'
  ];
const perfMetricsDisplayList =
  [ 'NCF_ARTIFACTPERFORMANCEDIFF' ];

const perfMetricsKeyPrefixList =
  [ 'Magnet.Artifacts.' ];


export const mapStateToProps = (state, ownProps) => {
  const pageType = getPageType(state);
  const metrics = getMetricsByJobId(state, ownProps.jobId) ?
    getMetricsByJobId(state, ownProps.jobId) : {};
  if (pageType === pageTypes.EXPORTTESTS)
    return { metrics: getExportMetrics(metrics, ownProps.scenarioName) };
  if (pageType === pageTypes.ARTIFACTREGRESSION)
    return {
      metrics: getDisplayMetrics(
        metrics, metricsDisplayList, perfMetricsDisplayList, perfMetricsKeyPrefixList)
    };
  return { metrics };
};

export default connect(
  mapStateToProps
)(JobMetricsInfoComponent);


// WEBPACK FOOTER //
// src/Containers/JobMetricsInfoContainer.jsx